import React from 'react';
import { MapPin, Clock, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Job } from '../../types/job';
import { colors } from '../../styles/theme';

interface JobCardProps {
  job: Job;
}

const JobCard: React.FC<JobCardProps> = ({ job }) => {
  return (
    <Link to={`/jobs/${job.id}`}>
      <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-xl font-bold mb-2" style={{ color: colors.primary }}>
              {job.title}
            </h3>
            <p className="text-gray-600">{job.department}</p>
          </div>
          <span 
            className="px-3 py-1 rounded-full text-sm font-medium"
            style={{
              backgroundColor: `${colors.primary}15`,
              color: colors.primary
            }}
          >
            {job.type}
          </span>
        </div>

        <p className="text-gray-600 mb-6 line-clamp-2">{job.description}</p>

        <div className="flex flex-wrap gap-4 text-sm text-gray-500">
          <div className="flex items-center">
            <MapPin className="w-4 h-4 mr-1" />
            {job.location}
          </div>
          <div className="flex items-center">
            <Clock className="w-4 h-4 mr-1" />
            {job.commitment}
          </div>
          <div className="flex items-center">
            <Users className="w-4 h-4 mr-1" />
            {job.department}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default JobCard;